var React = require('react');

function IconForward (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M549.9 240.4v543.4l264.6-264.6c3.9-3.9 3.9-10.2 0-14.1L549.9 240.4zM208.3 783.8l264.6-264.6c3.9-3.9 3.9-10.2 0-14.1L208.3 240.4v543.4z"}));
}

IconForward.displayName = "IconForward";

IconForward.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconForward;

IconForward.default = IconForward;
